import { SELECTOR_NAME_EN, SORT_ITEM_KEY } from "./constant";

//筛选器按照英文首字母排序
export const formatSortFiltersData = (dataObj:any) => {
    Object.keys(dataObj ?? {}).forEach((key) => {
      const sortKey = SELECTOR_NAME_EN?.[key];
      const item = dataObj[key];
      if(SORT_ITEM_KEY.includes(key)){
          item?.sort((a:any,b:any)=>{
          return a?.[sortKey]?.localeCompare(b?.[sortKey])
        })
      }
    })
    return dataObj;
}

//国家数据临时处理
export const formatCountryName = (resultData:any) => {
  resultData.newCountryList = {
    'Others': {
      en:'Others',
      ch:'其他',
    }
  }
  resultData?.country_list?.forEach((item:any) => {
    const name = item?.country_name_en;
    const nameEn = item?.country_name_en;
    const nameCh = item?.country_name_ch;
    resultData.newCountryList = {
      ...resultData.newCountryList,
      [name]:{
        en:nameEn,
        ch:nameCh,
      }
    }
  })
  return resultData;
}